module.exports = __webpack_public_path__ + "image/update-special.3e5a419.png";